<template>
  <div ref="scrollContainer" class="scroll-box">
    <div
      v-for="(item, index) in pages"
      :key="index + item"
      class="page-item"
      :ref="'page-' + index"
    >
      <slot :page="index + 1"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: { type: Number, required: true },
    nowPage: { type: Number, required: true },
    canScroll: { type: Boolean, default: false },
  },
  watch: {
    nowPage(newVal) {
      console.log(123, newVal);
      this.$nextTick(() => {
        this.scrollToPage(newVal);
      });
    },
  },
  computed: {
    pages() {
      return Array.from({ length: this.total }, () => this.$utils.guid());
    },
  },
  methods: {
    scrollToPage(pageNumber) {
      if (!this.canScroll) return;
      const container = this.$refs.scrollContainer;
      const pageEl = this.$refs["page-" + (pageNumber - 1)];
      if (container && pageEl && pageEl[0]) {
        const targetTop = pageEl[0].offsetTop;
        // 平滑滚动
        console.log(" top:", targetTop);
        console.log(" container", container);
        container.scrollTo({
          top: targetTop,
          behavior: "smooth",
        });
      }
    },
    // handleScroll() {

    //   const container = this.$refs.scrollContainer;
    //   const items = Array.from(container.querySelectorAll(".page-item"));
    //   const scrollTop = container.scrollTop;

    //   let currentPage = this.nowPage;
    //   let totalHeight = 0;

    //   for (let i = 0; i < items.length; i++) {
    //     const itemHeight = items[i].offsetHeight;
    //     totalHeight += itemHeight;
    //     if (scrollTop < totalHeight - itemHeight / 2) {
    //       currentPage = i + 1;
    //       break;
    //     }
    //   }
    //   if (currentPage !== this.nowPage) {
    //     this.$emit("update:nowPage", this.nowPage);
    //   }
    // },
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToPage(this.nowPage);
    });
  },
};
</script>

<style scoped>
.scroll-box {
  overflow-y: auto;
  position: relative;
}
</style>
